module.exports = __webpack_public_path__ + "static/media/user.8057f6d5.svg";